module.exports = __webpack_public_path__ + "static/img/AA12.38cb3a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/AA12.png
// module id = u+5o
// module chunks = 0